<template>
    <div class="d-block">
      
        <!-- <img :src="`https://image.tmdb.org/t/p/w500/${movie.backdrop_path}`" width="100%" alt=""> -->
        <div class="flex mb-4">
            <div class="w-1/4 bg-grid-color-secondary h-12">
                <vs-input placeholder="Imdb id" v-model="imdbId" @change="imdbData" />
                <div id="preview">
                    <img v-if="movie.poster" :src="movie.poster" width="300" />
                </div>
            </div>
            <div class="w-3/4 bg-grid-color h-12">
                <div class="con-tab-ejemplof">
                    <div class="vx-row">
                        <div class="vx-col w-full mb-6">
                            <vs-checkbox class="inline-flex" :checked="movie.comming_soon">Comming Soon</vs-checkbox>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full mb-6">
                            <vs-input class="w-full" label-placeholder="Arabic Name" v-model="movie.ar_title" />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-6">
                            <vs-input class="w-full" label-placeholder="English Name" v-model="movie.en_title" />
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full mb-6">
                            <vs-input class="w-full" label-placeholder="Imdb Rating" v-model="movie.rating" />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-6">
                            <vs-input class="w-full" label-placeholder="Language" v-model="movie.language" />
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full mb-6">
                            <vs-input class="w-full" label-placeholder="Release date" v-model="movie.release_date" />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-6">
                            <vs-input class="w-full" label-placeholder="Year" v-model="movie.year" />
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full mb-6">
                            <vs-input class="w-full" label-placeholder="Arabic tagline" v-model="movie.ar_tagline" />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-6">
                            <vs-input type="email" class="w-full" label-placeholder="English tagline"
                                v-model="movie.en_tagline" />
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col sm:w-1/2  w-full mb-6">
                            <vs-input class="w-full" label-placeholder="Trailer" v-model="movie.trailer" />
                        </div>
                        <div class="vx-col sm:w-1/4 w-full mb-5 mt-3">
                            <vs-button color="danger" type="border" icon="videocam" target :href="movie.trailer">watch
                                Trailer</vs-button>

                        </div>

                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full mb-6">
                            <vs-textarea label="Arabic Plot" v-model="movie.ar_plot" />
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full mb-6">
                            <vs-textarea label="English Plot" v-model="movie.en_plot" />
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full mb-6">
                            <label for="">Genres</label>
                            <vSelect :filterable="false" :multiple="true" v-model="movie.genres"
                                :options="$store.state.genres.all" placeholder="select genres">

                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.name }}
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.name }}
                                    </div>
                                </template>
                            </vSelect>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full mb-6">
                            <label for="">Cast</label>
                            <vSelect v-if="movie.cast.length!=0" :filterable="false" :multiple="true"
                                v-model="movie.cast" :options="imdbInfo.credits.cast" placeholder="select cast">

                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.name }} - ({{option.character}})
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.name }}
                                    </div>
                                </template>
                            </vSelect>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <vs-button class="mr-3 mb-2" @click="formSubmitted">Submit</vs-button>
                            <vs-button color="warning" type="border" class="mb-2">
                                Reset</vs-button>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {
        FormWizard,
        TabContent
    } from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';
    export default {
        data() {
            return {
                firstName: "",
                imdbInfo: '',
                imdbId: '',
                movie: {
                    backdrop_path: '',
                    comming_soon: false,
                    ar_title: '',
                    en_title: '',
                    ar_tagline: '',
                    en_tagline: '',
                    ar_plot: '',
                    en_plot: '',
                    rating: '',
                    duration: '',
                    trailer: '',
                    imdb: '',
                    poster: '',
                    kind: '',
                    release_date: '',
                    year: '',
                    genres: [],
                    cast: [],
                    language: '',
                    posterFile:''
                }
                /// other data....
            }
        },
        created() {
            this.$store.dispatch('genres/fetchGenres');
            //this.imdbData();
        },
        methods: {
            onFileChange(e) {
                const file = e.target.files[0];
                this.movie.posterFile = URL.createObjectURL(file);
            },
            formSubmitted() {
                 const data = new FormData();
                 data.append('comming_soon',this.movie.comming_soon);
                 data.append('ar_title',this.movie.ar_title);
                 data.append('en_title',this.movie.en_title);
                 data.append('ar_tagline',this.movie.ar_tagline);
                 data.append('en_tagline',this.movie.en_tagline);
                 data.append('ar_plot',this.movie.ar_plot);
                 data.append('en_plot',this.movie.en_plot);
                 data.append('rating',this.movie.rating);
                 data.append('duration',this.movie.duration);
                 data.append('trailer',this.movie.trailer);
                 data.append('imdb',this.movie.imdb);
                 data.append('poster',this.movie.poster);
                 data.append('kind',this.movie.kind);
                 data.append('release_date',this.movie.release_date);
                 data.append('year',this.movie.year);
                 data.append('genres',JSON.stringify(this.movie.genres));
                 data.append('cast',JSON.stringify(this.movie.cast));
                 data.append('language',this.movie.language);
                 data.append('posterFile',this.movie.posterFile);
                this.axios.post(`${this.$apiUrl}/movies`,data).then(res=>{
                    console.log(res.data);
                });
            },
            imdbData() {
                this.$vs.loading()
                this.axios.get(`${this.$apiUrl}/imdb/${this.imdbId}`).then(res => {
                    this.imdbInfo = res.data;
                    this.movie.ar_tagline = (res.data.ar.tagline) ? res.data.ar.tagline : res.data.tagline;
                    this.movie.en_tagline = res.data.tagline;
                    this.movie.ar_plot = (res.data.ar.overview) ? res.data.ar.overview : res.data.Plot;
                    this.movie.en_plot = res.data.Plot;
                    this.movie.genres = res.data.genres;
                    this.movie.release_date = res.data.release_date;
                    this.movie.year = res.data.Year;
                    this.movie.en_title = res.data.Title;
                    this.movie.ar_title = res.data.ar.original_title;
                    this.movie.rating = res.data.imdbRating;
                    this.movie.cast = res.data.credits.cast;
                    this.movie.backdrop_path = res.data.backdrop_path;
                    this.movie.language = res.data.Language;
                    this.movie.trailer = res.data.Trailer;
                    this.movie.poster = res.data.Poster;
                    this.movie.comming_soon = (res.data.status == "Released") ? false : true;
                    this.$vs.loading.close()
                });
            }
        },
        components: {
            FormWizard,
            TabContent,
            vSelect
        }
    }
</script>
<style lang="scss">
    .vs-input {
        width: 90%;
        margin-top: 10px;
    }
</style>